import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Keyword from "./Keyword"
import formatThousandNumber from "../../../../../helpers/common/formatThousandNumber"

class ListKeywords extends Component {
    render() {
        const {keywords, onRemove, onCountTotal, countResults} = this.props

        return (
            <div className="ListKeywords">
                <table className="table">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Term</th>
                        <th>Last 24h ({formatThousandNumber(countResults)})</th>
                        <th>Status</th>
                        <th>Last active time</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        keywords.map((keyword, index) => {
                            return (
                                <Keyword
                                    onCountTotal={onCountTotal}
                                    onRemove={onRemove}
                                    key={keyword._id} keyword={keyword} order={index + 1}/>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        )
    }
}

ListKeywords.propTypes = {
    countResults: PropTypes.number.isRequired,
    keywords: PropTypes.array.isRequired,
    onRemove: PropTypes.func.isRequired,
    onCountTotal: PropTypes.func,
}

export default ListKeywords



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/keywords/components/ListKeywords.js